import styled from 'styled-components';
import { FontFamilyMedium, FontSize22, FontSize14, FontSize20, FontSize12, FontFamilyBold, FontSize16 } from '../fonts';
import { TextBlock } from '../text';
import { ButtonBaseStyle } from '../Buttons/baseStyle';

export const Container = styled.div`
    padding: 0 10px 40px 10px;
    position: relative;
    max-width: 650px;
    margin: 0 auto;
`;

export const Title = styled.h2`
    ${FontFamilyMedium};
    ${FontSize22};
    margin: 0;
    text-align: center;
    font-weight: 500;
`;

export const InputBooleanContainer = styled.div`
    width: 100%;
    max-width: 200px;
`;

const Description = styled(TextBlock)`
    ${FontSize14};
    text-align: center;
    margin-top: 9px;
    line-height: 22px;
`;

export const DescriptionMobile = styled(Description)`
    margin-top: 11px;
    ${props => props.theme.mediaQueries.desktop} {
        display: none;
    }
`;

export const DescriptionDesktop = styled(Description)`
    display: none;
    ${props => props.theme.mediaQueries.desktop} {
        display: block;
    }
`;

export const EnergyResourceContainer = styled.div`
    margin: 20px 0 16px 8px;
    ${props => props.theme.mediaQueries.desktop} {
        margin: 20px 0 16px 32px;
    }
`;

export const ResourceContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const IconContainer = styled.div`
    margin-right: 13px;
    ${props => props.theme.mediaQueries.desktop} {
        margin-right: 16px;
    }
`;

export const ResourceTitle = styled.span`
    ${FontSize20};
    color: ${props => props.theme.color[props.color]};
`;

export const ResourceDescription = styled(TextBlock)`
    ${FontSize12};
`;

export const OptionContainer = styled.div`
    position: relative;
    border-radius: 25px;
    padding: 24px 30px 24px 18px;
    box-shadow: 0 10px 35px 0 rgba(81, 129, 186, 0.25);
    background-color: #ffffff;

    &:hover {
        cursor: pointer;
    }

    ${props => props.theme.mediaQueries.desktop} {
        display: flex;
        align-items: center;
        padding: 24px 30px;
    }
`;

export const OptionContainerGradientWrapper = styled.div`
    background: ${props => props.isChecked ? props.theme.color.greenBlue : 'white'};
    border-radius: 25px;
    padding: 1px;
    margin-bottom: 20px;
`;

export const PricesContainer = styled.div`
    margin-left: 30px;
    ${props => props.theme.mediaQueries.desktop} {
        flex: 1;
        display: flex; 
        flex-wrap: wrap;
        justify-content: ${props => props.justifyContent || 'flex-start'};
    }
`;

export const PriceContainerMobile = styled.div`
    display: block;
    margin-top: ${props => props.isFirst ? 0 : '12px'};
    ${props => props.theme.mediaQueries.desktop} {
        display: none;
    }
`;

export const PriceContainerDesktop = styled.div`
    display: none;
    ${props => props.theme.mediaQueries.desktop} {
        display: flex;
        width: 50%;
        justify-content: center;
    }
`;

export const PriceContainer = styled.div`
    ${props => props.theme.mediaQueries.desktop} {
        width: 150px;
    }
`;

export const PriceLabel = styled(TextBlock)`
    ${FontSize14};
    margin-bottom:  ${props => props.isMobile ? '0px' : '8px'};
    line-height: 1.71;
`;

export const PriceValue = styled(TextBlock)`
    ${FontFamilyBold};
    ${FontSize16};
    line-height: 1.5;
`;

export const PriceOldValue = styled(TextBlock)`
    ${FontSize12};
    text-decoration: line-through;
    text-align: ${props => props.isMobile ? 'right' : 'left'};
`;

export const MobilePriceExtraLabel = styled(TextBlock)`
    color: ${props => props.theme.color.orange};
    ${FontSize16};
    ${FontFamilyMedium};
    line-height: 24px;
    margin: 16px 0 0 30px;
    ${props => props.theme.mediaQueries.desktop} {
        display: none;
    }
`;

export const LabelPriceContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
`;

export const GasOptionContainer = styled.div`
    position: relative;
    border-radius: 35px;
    border: solid 1px rgba(151, 151, 151, 0.35);
    padding: 24px 30px 24px 7px;
    margin-top: 45px;

    ${props => props.theme.mediaQueries.desktop} {
        display: flex;
        align-items: center;
        padding: 24px 30px;
    }
`;

export const ConfirmButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    ${props => props.theme.mediaQueries.desktop} {
        position: relative;
    }
`;

export const ConfirmButton = styled.button`
    margin-top: 25px;
    ${ButtonBaseStyle};
    color: white;
    height: 60px;
    font-size: 20px;
    width: 100%;
    transition: opacity 0.2 ease-in-out;
    opacity: ${props => props.disabled ? 0.5 : 1};
    border-radius: 0;

    ${props => props.theme.mediaQueries.desktop} {
        border-radius: 30px;
        width: 180px;
    }
`;

export const WarningMessageContainer = styled.div`
    width: 50%;
    margin-top: 30px;
    margin-left: 20px;
`;

export const Spacer = styled.div`
    height: 80px;
    ${props => props.theme.mediaQueries.desktop} {
        height: 0px;
    }
`;

export const OptionContainerTitle = styled.div`
    margin: 0;
    position: absolute;
    top: -8px;
    right: 0;
    left: 0;
    background-color: transparent;
    display: flex;
    justify-content: center;
`;

export const OptionContainerTitleText = styled(TextBlock)`
    ${FontFamilyMedium};
    margin: 0;
    font-size: 14px;
    background-color: white;
    text-align: center;
    font-weight: 500;
    padding: 0 20px;
`;